import {
  ACTIVATE_REBOOKING,
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  CHECKOUT_ADD_ITEM,
  CHECKOUT_APPLY_PARTNERSHIP_STATUS,
  CHECKOUT_APPLY_PROMO_CODE,
  CHECKOUT_APPLY_PROMO_CODE_FAILED,
  CHECKOUT_APPLY_VELOCITY_BURN,
  CHECKOUT_CLEAR_CART,
  CHECKOUT_CLEAR_VELOCITY_BURN,
  CHECKOUT_FETCHING_PROMO_CODE,
  CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_INITIALISE,
  CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW,
  CHECKOUT_PROCESS_CANCEL,
  CHECKOUT_PROCESS_FAILURE,
  CHECKOUT_PROCESS_START,
  CHECKOUT_PROCESS_SUCCESS,
  CHECKOUT_REMOVE_ITEM,
  CHECKOUT_RESET_FLIGHT_ITEMS,
  CHECKOUT_RESET_PROMO_CODE,
  CHECKOUT_RESTORE_CART,
  CHECKOUT_RESTORE_FORM,
  CHECKOUT_RESTORE_PAYMENT,
  CHECKOUT_SET_FORM,
  CHECKOUT_CLEAR_TRAVELLER_FORM,
  CHECKOUT_SET_RESTORE_CART_STATUS,
  CHECKOUT_TOGGLE_DEV_TOOLS,
  CHECKOUT_SET_LUXPLUS_UPSELL_DATA,
  CHECKOUT_SET_POST_PURCHASE,
  CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_SET_SPECIAL_REQUEST,
  CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS,
  CHECKOUT_SET_VELOCITY_SSO,
  CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_TOGGLE_CREDIT,
  CHECKOUT_TOGGLE_GIFT_CARD,
  CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER,
  CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING, CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE,
  CHECKOUT_UPDATE_EXPERIENCE_ITEM,
  CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE,
  CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE,
  CHECKOUT_UPDATE_ECONOMY_LUX_COUPLES_CONFIGURATION,
  CHECKOUT_CLEAR_ECONOMY_LUX_COUPLES_CONFIGURATION,
  CHECKOUT_UPDATE_HOTEL_ITEM_PRICING,
  CHECKOUT_UPDATE_ITEM,
  CHECKOUT_UPDATE_PAYMENT_SELECTION,
  CHECKOUT_SET_MULTI_CART_ITEM_MODE,
  CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE,
  CHECKOUT_RESET_FORM,
  CHECKOUT_CLEAR_CART_RESTORE_PRICE,
  CHECKOUT_AGENT_BOOKING_DETAILS,
  CHECKOUT_SET_STRIPE_PAYMENT_METHOD,
  CHECKOUT_BUSINESS_BOOKING_DETAILS,
  CHECKOUT_ADD_ARRIVAL_DETAILS,
  CHECKOUT_SET_ARRIVAL_DETAILS_TIME,
  CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER,
  CHECKOUT_SET_PAYTO_BANK, CHECKOUT_SET_COMMS_RESUBSCRIBE,
  CHECKOUT_FETCHING_PAYMENT_LINK,
  CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
  CHECKOUT_SET_PAYMENT_LINK,
  CHECKOUT_SET_ORDER_ID,
  CHECKOUT_RESET_COMMISSION,
  CHECKOUT_TOGGLE_LOYALTY_SIGNUP,
  CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN,
  CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN,
  CHECKOUT_SET_MODE,
  CHECKOUT_SET_HAS_CAR_HIRE_INTENTION,
  CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP,
  SET_BEDBANK_SESSION,
  CHECKOUT_CLEAR_RESTORED_PROMO_CODE,
  CHECKOUT_CLEAR_RESTORED_USE_CREDIT,
  CHECKOUT_SET_APPROVAL_REQUEST_ID,
  CHECKOUT_CLEAR_APPROVAL_REQUEST_ID,
  SET_PAYPAL_PAYMENT_TYPE,
  CHECKOUT_UPDATE_TRAVELLER_FORM_PREREQUISITE,
  CHECKOUT_REMOVE_TRAVELLER_FORM_PREREQUISITE,
  CHECKOUT_TOGGLE_FAILED_ITEMS,
  CHECKOUT_UPDATE_FLIGHT_SEAT_SELECTIONS,
  CHECKOUT_CLEAR_FLIGHT_SEAT_SELECTIONS,
} from 'actions/actionConstants'
import {
  CHECKOUT_CREATE_CART_QUOTE,
  CHECKOUT_UPDATE_CART_QUOTE,
  CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER,
  CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
  CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO,
  CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO,
  CREATE_STRIPE_PAYMENT_METHOD,
  FETCH_COMMMISSION_PROMO,
  FETCH_FINAL_FLIGHT_FARES,
  FETCH_TRAVELLER_FORM_SCHEMA,
  FETCH_VELOCITY_MEMBER_DETAILS,
  UPDATE_BEDBANK_SESSION,
  FETCH_BEDBANK_SESSION,
  FETCH_COMMISSION_PROMO_CODE,
} from 'actions/apiActionConstants'
import { CHECKOUT_ITEM_TYPE_BEDBANK, CHECKOUT_ITEM_TYPE_EXPERIENCE } from 'constants/checkout'
import { isBundleAndSaveItem, isFlightItem } from 'lib/checkout/checkoutUtils'
import { initialFormState } from 'lib/checkout/form'
import { omitKeys } from 'lib/object/objectUtils'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'
import uuidV4 from 'lib/string/uuidV4Utils'
import { VELOCITY_SSO_STATUS } from 'constants/partnerships'
import config from 'constants/config'
import { unique } from 'lib/array/arrayUtils'
import { AGENT_HUB_PAYMENT_MODE } from 'constants/payment'

export const initialState: App.CheckoutState = {
  cart: {
    businessBookingDetails: null,
    /** @ts-ignore null is required for multi cart to initialise correct, but not on types... */
    cartId: null,
    /** @ts-ignore null is required for multi cart to initialise correct, but not on types... */
    regionCode: null,
    /** @ts-ignore null is required for multi cart to initialise correct, but not on types... */
    currencyCode: null,
    items: [],
    specialRequests: {},
    transactionKey: uuidV4(),
    isGift: false,
    isDevToolsEnabled: false,
    isAbandonedCart: false,
    arrivalFlightNumber: null,
    isMultiItemMode: config.UNIVERSAL_CHECKOUT_MULTI_CART_ITEMS_ENABLED,
    restoredCartDetails: undefined,
    agentBookingDetails: null,
    csCartQuoteStatus: undefined,
    csCartQuoteError: undefined,
    csCartQuoteId: undefined,
    arrivalDetails: {},
    isMultiCart: undefined,
    hasCarHireIntention: false,
    hasFailedItems: false,
  },
  sessions: {},
  form: initialFormState,
  payment: {
    useCredit: false,
    useGiftCard: false,
    paymentSelected: 'full',
    partnerships: {},
    modals: {
      velocity: {
        isActive: false,
        isClean: true,
      },
    },
    sso: {
      velocity: {
        loginStatus: VELOCITY_SSO_STATUS.LOGGED_OUT,
        isAuthenticated: false,
        token: undefined,
        isTokenExpired: false,
        paymentAttempted: undefined,
      },
    },
    agentHubPaymentMode: AGENT_HUB_PAYMENT_MODE.PAY_NET_AMOUNT,
  },
  isPaymentRestored: false,
  isFormRestored: false,
  schemaData: {},
  fetchingSchemaData: {},
  schemaDataErrors: {},
  isFetchingVelocityData: false,
  isCartRestored: false,
  isFetchingBedbankOrder: false,
  isCreatingBedbankChangeDatesSession: false,
  travellerFormPrerequisites: {},
  promo: undefined,
  commission: undefined,
  corporatePromoForm: {
    state: 'hidden',
  },
  friendsAndFamilyPromoForm: {
    state: 'hidden',
  },
  processing: false,
  processed: false,
  cardProcessingErrorCount: 0,
  restoreCart: {
    status: 'idle',
    errorMsg: null,
    restoredCartId: undefined,
  },
  modifyFlightView: 'home',
  csDepositPercentageOverride: false,
  depositPercentage: 0,
  merchantFeePaymentType: null,
  paypalPaymentType: null,
  orderFailure: false,
  insuranceAgentUpsellData: undefined,
  luxPlusUpsellData: undefined,
  loyalty: {
    enrolCustomerAtCheckout: false,
    pointsToBurn: 0,
  },
  stripePaymentMethod: {
    isCreatingStripePaymentMethod: false,
    paymentMethodId: undefined,
    cardBrand: undefined,
    cardFunding: undefined,
    cardCountry: undefined,
  },
  selectedPayToBank: undefined,
  securePayment: {
    isFetchingLink: false,
    securePaymentLink: undefined,
    securePaymentLinkType: undefined,
  },
  orderId: undefined,
  failedTransactionKey: undefined,
  orderTransactionKey: undefined,
  commissionData: undefined,
}

const apiCalls = apiReducerSwitch<App.CheckoutState>({
  [FETCH_COMMISSION_PROMO_CODE]: {
    request: () => ({
      isFetchingCommmission: true,
      commissionData: undefined,
    }),
    success: (state, action) => ({
      isFetchingCommmission: false,
      commissionData: action.data,
    }),
    failure: () => ({
      isFetchingCommmission: false,
      commissionData: undefined,
    }),
  },
  [FETCH_TRAVELLER_FORM_SCHEMA]: {
    request: (state, action) => ({
      fetchingSchemaData: {
        ...state.fetchingSchemaData,
        [action.key]: true,
      },
    }),
    success: (state, action) => ({
      schemaData: {
        ...state.schemaData,
        [action.key]: action.data,
      },
      fetchingSchemaData: {
        ...state.fetchingSchemaData,
        [action.key]: false,
      },
    }),
    failure: (state, action) => {
      return {
        fetchingSchemaData: {
          ...state.fetchingSchemaData,
          [action.key]: false,
        },
        schemaDataErrors: {
          ...state.schemaDataErrors,
          [action.key]: {
            name: action.error.message,
            status: action.error.status,
          },
        },
      }
    },
  },
  [UPDATE_BEDBANK_SESSION]: {
    request: (state, action) => {
      if (!action.sessionId) {
        return
      }
      return {
        sessions: {
          ...state.sessions,
          [action.sessionId]: {
            state: 'updating',
            data: null,
          },
        },
      }
    },
    success: (state, action) => {
      // Assumption, there is only a single bedbank offer (possibly multiple rooms) in the cart
      const { sessionId, oldSessionId } = action.data
      const newCartItems = state.cart.items.map((item) => {
        if (item.itemType !== CHECKOUT_ITEM_TYPE_BEDBANK || item.sessionId !== oldSessionId) { return item }
        return { ...item, sessionId }
      })

      return {
        cart: { ...state.cart, items: newCartItems },
        sessions: oldSessionId ? {
          ...state.sessions,
          [oldSessionId]: {
            state: 'updated',
            data: null,
          },
        } : undefined,
      }
    },
  },
  [CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO]: {
    request: (state, action) => ({
      corporatePromoForm: {
        ...state.corporatePromoForm,
        emailSubmitted: action.submittedEmail,
        state: 'loading',
      },
    }),
    success: (state) => ({
      corporatePromoForm: {
        ...state.corporatePromoForm,
        state: 'done',
        error: undefined,
      },
    }),
    failure: (state, action) => ({
      corporatePromoForm: {
        ...state.corporatePromoForm,
        state: 'error',
        emailSubmitted: state.corporatePromoForm.emailSubmitted,
        error: action?.error?.errors.map((m: any) => {
          if (m === 'matchingCorpEmailDomainRequiredForCreate') {
            return 'Email address is not valid for the coupon code'
          } else if (m === 'Service Error: Service Error received: 400') {
            return 'Failed to create promo code. Please try again later'
          } else {
            return m.message ? m.message : m.toString()
          }
        }),
      },
    }),
  },
  [CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO]: {
    request: (state, action) => ({
      friendsAndFamilyPromoForm: {
        ...state.friendsAndFamilyPromoForm,
        emailSubmitted: action.submittedEmail,
        state: 'loading',
      },
    }),
    success: (state) => ({
      friendsAndFamilyPromoForm: {
        ...state.friendsAndFamilyPromoForm,
        state: 'done',
        error: undefined,
      },
    }),
    failure: (state, action) => ({
      friendsAndFamilyPromoForm: {
        ...state.friendsAndFamilyPromoForm,
        state: 'error',
        emailSubmitted: state.friendsAndFamilyPromoForm.emailSubmitted,
        error: action?.error?.errors.map((m: any) => {
          if (m === 'matchingCorpEmailDomainRequiredForCreate') {
            return 'Email address is not valid for the coupon code'
          } else if (m === 'Service Error: Service Error received: 400') {
            return 'Failed to create promo code. Please try again later'
          } else {
            return m.message ? m.message : m.toString()
          }
        }),
      },
    }),
  },
  [FETCH_COMMMISSION_PROMO]: {
    request: () => ({
      isFetchingCommmission: true,
    }),
    success: (state, action) => ({
      commission: action.data,
      isFetchingCommmission: false,
    }),
    failure: () => ({
      isFetchingCommmission: false,
    }),
  },
  [CREATE_STRIPE_PAYMENT_METHOD]: {
    request: () => ({
      stripePaymentMethod: {
        isCreatingStripePaymentMethod: true,
        cardBrand: undefined,
        cardFunding: undefined,
        paymentMethodId: undefined,
        cardCountry: undefined,
      },
    }),
    success: (_state, action) => ({
      stripePaymentMethod: {
        isCreatingStripePaymentMethod: false,
        cardBrand: action.data.paymentMethod?.card?.brand,
        cardFunding: action.data.paymentMethod?.card?.funding,
        paymentMethodId: action.data.paymentMethod?.id,
        cardCountry: action.data.paymentMethod?.card?.country ?? undefined,
      },
    }),
    failure: (state) => ({
      stripePaymentMethod: {
        ...state.stripePaymentMethod,
        isCreatingStripePaymentMethod: false,
      },
    }),
  },
  [CHECKOUT_CREATE_CART_QUOTE]: {
    request: (state) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'loading',
      },
    }),
    success: (state, action) => ({
      cart: {
        ...state.cart,
        csCartQuoteId: action.data.id,
        csCartQuoteStatus: 'created',
      },
    }),
    failure: (state, action) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'error',
        csCartQuoteError: action.error,
      },
    }),
  },
  [CHECKOUT_UPDATE_CART_QUOTE]: {
    request: (state) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'loading',
      },
    }),
    success: (state) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'created',
      },
    }),
    failure: (state, action) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'error',
        csCartQuoteError: action.error,
      },
    }),
  },
  [CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER]: {
    request: () => ({
      isCartRestored: false,
      isFetchingBedbankOrder: true,
    }),
    success: () => ({
      isCartRestored: true,
      isFetchingBedbankOrder: false,
    }),
    failure: () => ({
      isCartRestored: false,
      isFetchingBedbankOrder: false,
    }),
  },
  [CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION]: {
    request: () => ({
      isCreatingBedbankChangeDatesSession: true,
    }),
    success: () => ({
      isCreatingBedbankChangeDatesSession: false,
    }),
    failure: () => ({
      isCreatingBedbankChangeDatesSession: false,
    }),
  },
  [FETCH_BEDBANK_SESSION]: {
    request: (state, action) => ({
      sessions: {
        ...state.sessions,
        [action.sessionId]: {
          state: 'loading',
          data: null,
        },
      },
    }),
    success: (state, action) => ({
      sessions: {
        ...state.sessions,
        [action.sessionId]: {
          state: 'done',
          data: action.data ?? null,
        },
      },
    }),
    failure: (state, action) => ({
      sessions: {
        ...state.sessions,
        [action.sessionId]: {
          state: 'error',
          data: null,
        },
      },
    }),
  },
  [FETCH_FINAL_FLIGHT_FARES]: {
    request: (state, action) => {
      const { itemId } = action
      return {
        cart: {
          ...state.cart,
          items: state.cart.items.map((item) =>
            (!isFlightItemIdMatch(item, itemId)) ? item : {
              ...item,
              hasFinalFare: false,
              fetchingFare: true,
              fareFetchError: undefined,
            }),
        },
      }
    },
    success: (state, action) => {
      const { itemId, data } = action

      return {
        cart: {
          ...state.cart,
          items: state.cart.items.map(item =>
            (!isFlightItemIdMatch(item, itemId)) ? item : {
              ...item,
              totalFare: data.totalFare,
              otherFees: data.otherFees,
              flights: item.flights?.map((flight, index) => ({
                ...flight,
                cost: data.costs[index],
              })),
              hasFinalFare: true,
              fetchingFare: false,
              fareFetchError: undefined,
            }),
        },
      }
    },
    failure: (state, action) => ({
      cart: {
        ...state.cart,
        items: state.cart.items.map((item) =>
          (item.itemId !== action.itemId) ? item : {
            ...item,
            hasFinalFare: false,
            fetchingFare: false,
            fareFetchError: action.error,
          }),
      },
    }),
  },
  [FETCH_VELOCITY_MEMBER_DETAILS]: {
    request: (state) => ({
      payment: {
        ...state.payment,
        partnerships: {
          ...state.payment.partnerships,
        },
      },
      isFetchingVelocityData: true,
    }),
    success: (state, action) => ({
      payment: {
        ...state.payment,
        partnerships: {
          ...state.payment.partnerships,
          velocity: {
            ...state.payment.partnerships.velocity,
            burn: {
              ...state.payment.partnerships.velocity?.burn,
              membershipId: action.data.membershipId,
              pointBalance: action.data.pointBalance,
              firstName: action.data.firstName,
              lastName: action.data.lastName,
            },

          },
        },
      },
      isFetchingVelocityData: false,
    }),
    failure: (state) => ({
      payment: {
        ...state.payment,
        partnerships: {
          ...state.payment.partnerships,
        },
      },
      isFetchingVelocityData: false,
    }),
  },
})

const isFlightItemIdMatch = (
  item: App.Checkout.AnyItem,
  itemId: string,
): item is App.Checkout.FlightItem => {
  return item.itemId === itemId
}

export default createAppReducer<App.CheckoutState>(initialState, {
  [API_CALL_REQUEST]: apiCalls,
  [API_CALL_FAILURE]: apiCalls,
  [API_CALL_SUCCESS]: apiCalls,
  [CHECKOUT_INITIALISE]: (state, action) => {
    const transactionKey = uuidV4()
    return {
      ...initialState,
      sessions: state.sessions,
      cart: {
        ...initialState.cart,
        cartId: transactionKey,
        regionCode: action.params.regionCode,
        currencyCode: action.params.currencyCode,
        items: action.items,
        transactionKey,
        isGift: action.params.isGift,
        isAbandonedCart: false,
        isMultiItemMode: state.cart.isMultiItemMode,
        mode: action.params.mode ?? 'default',
        existingOrder: action.params.order,
        connectedRoomOfferIds: action.params.connectedRoomOfferIds,
        isMultiCart: action.params.isMultiCart,
        restoredCartDetails: action.params.restoreCartDetails,
        approvalRequestId: action.params.approvalRequestId,
      },
      isCartRestored: true,
      isFormRestored: false,
    }
  },
  [CHECKOUT_RESTORE_CART]: (state, action) => ({
    cart: { ...state.cart, ...action.cartState, isAbandonedCart: false },
    isCartRestored: true,
  }),
  [CHECKOUT_RESTORE_PAYMENT]: (state, action) => ({
    payment: { ...state.payment, ...action.state },
    isPaymentRestored: true,
  }),
  [CHECKOUT_CLEAR_CART]: (state) => ({
    ...state,
    cart: {
      ...initialState.cart,
    },
  }),
  [CHECKOUT_CLEAR_CART_RESTORE_PRICE]: (state) => ({
    ...state,
    cart: {
      ...state.cart,
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        originalMemberTotal: undefined,
        originalTotal: undefined,
      },
    },
  }),
  [CHECKOUT_RESTORE_FORM]: (state, action) => ({
    form: { ...state.form, ...action.formState },
    isFormRestored: true,
  }),
  [CHECKOUT_RESET_FORM]: () => ({
    form: initialFormState,
  }),
  [CHECKOUT_RESET_COMMISSION]: () => ({
    commissionData: undefined,
    commission: undefined,
  }),
  [CHECKOUT_SET_COMMS_RESUBSCRIBE]: (state, action) => ({
    form: {
      ...state.form,
      commsResubscribe: action.commsResubscribe,
    },
  }),
  [CHECKOUT_UPDATE_FLIGHT_SEAT_SELECTIONS]: (state, action) => {
    const currentSelections = state.form.flightSeatSelections ?? {}
    const hasSeatSelections = Object.values(action.seatSelections ?? {}).some((travellerSeats) => {
      return travellerSeats && Object.keys(travellerSeats).length > 0
    })

    if (!hasSeatSelections) {
      if (!(action.key in currentSelections)) { return }

      const { [action.key]: _removed, ...remaining } = currentSelections
      return {
        form: {
          ...state.form,
          flightSeatSelections: remaining,
        },
      }
    }

    return {
      form: {
        ...state.form,
        flightSeatSelections: {
          ...currentSelections,
          [action.key]: action.seatSelections,
        },
      },
    }
  },
  [CHECKOUT_CLEAR_FLIGHT_SEAT_SELECTIONS]: (state) => {
    return {
      form: {
        ...state.form,
        flightSeatSelections: {},
      },
    }
  },
  [CHECKOUT_UPDATE_ECONOMY_LUX_COUPLES_CONFIGURATION]: (state, action) => ({
    form: {
      ...state.form,
      economyLuxCouplesConfiguration: action.configuration,
    },
  }),
  [CHECKOUT_CLEAR_ECONOMY_LUX_COUPLES_CONFIGURATION]: (state) => ({
    form: {
      ...state.form,
      economyLuxCouplesConfiguration: undefined,
    },
  }),
  [CHECKOUT_UPDATE_ITEM]: (state, action) => {
    // Preserve ordering of items
    const idx = state.cart.items.findIndex(item => item.itemId === action.item.itemId)
    const newItems = idx === -1 ?
        [...state.cart.items, action.item] :
        [...state.cart.items.slice(0, idx), action.item, ...state.cart.items.slice(idx + 1)]
    const itemCountChanged = newItems.length !== state.cart.items.length
    return {
      cart: {
        ...state.cart,
        items: newItems,
        restoredCartDetails: itemCountChanged ? {
          ...state.cart.restoredCartDetails,
          originalMemberTotal: undefined,
          originalTotal: undefined,
        } : state.cart.restoredCartDetails,
      },
    }
  },
  [CHECKOUT_ADD_ITEM]: (state, action) => ({
    cart: {
      ...state.cart,
      items: [...state.cart.items, action.item],
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        originalMemberTotal: undefined,
        originalTotal: undefined,
      },
    },
  }),
  [CHECKOUT_REMOVE_ITEM]: (state, action) => ({
    cart: {
      ...state.cart,
      items: state.cart.items.filter(item => item.itemId !== action.itemId),
      specialRequests: omitKeys([action.itemId], state.cart.specialRequests),
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        originalMemberTotal: undefined,
        originalTotal: undefined,
      },
    },
  }),
  [CHECKOUT_SET_FORM]: (state, action) => ({
    form: action.form,
  }),
  [CHECKOUT_CLEAR_TRAVELLER_FORM]: (state, action) => ({
    form: {
      ...state.form,
      travellerForms: state.form.travellerForms.filter(f => f.id !== action.travellerId),
    },
  }),
  [CHECKOUT_UPDATE_PAYMENT_SELECTION]: (state, action) => ({
    payment: {
      ...state.payment,
      paymentSelected: action.paymentSelected,
    },
  }),
  [CHECKOUT_SET_SPECIAL_REQUEST]: (state, action) => ({
    cart: {
      ...state.cart,
      specialRequests: {
        ...state.cart.specialRequests,
        [action.itemId]: action.request,
      },
    },
  }),
  [CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED]: (state, action) => ({
    cart: {
      ...state.cart,
      connectedRoomOfferIds: unique([
        ...(state.cart.connectedRoomOfferIds ?? []),
        action.offerId,
      ]),
    },
  }),
  [CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED]: (state, action) => {
    return {
      cart: {
        ...state.cart,
        connectedRoomOfferIds: (state.cart.connectedRoomOfferIds ?? []).filter(id => id !== action.offerId),
      },
    }
  },
  [CHECKOUT_SET_LUXPLUS_UPSELL_DATA]: (state, action) => ({
    ...state,
    luxPlusUpsellData: action.eventData,
  }),
  [CHECKOUT_PROCESS_START]: (state) => ({
    error: undefined,
    processing: true,
    processed: false,
    orderId: undefined,
    // Store the current transaction key before order processing starts
    orderTransactionKey: state.cart.transactionKey,
  }),
  [CHECKOUT_PROCESS_CANCEL]: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        transactionKey: uuidV4(),
        items: state.cart.items.map(item => ({ ...item, transactionKey: uuidV4() })),
      },
      processing: false,
      processed: false,
      orderFailure: true,
      orderId: undefined,
      // Store the transactionKey from when the order was created, not the current cart transactionKey
      failedTransactionKey: state.orderTransactionKey,
    }
  },
  [CHECKOUT_PROCESS_SUCCESS]: (_state) => ({
    ...initialState,
    processing: false,
    processed: true,
    orderFailure: false,
    failedTransactionKey: undefined,
    orderTransactionKey: undefined,
  }),
  [CHECKOUT_PROCESS_FAILURE]: (state, action) => ({
    cart: {
      ...state.cart,
      transactionKey: uuidV4(),
      items: state.cart.items.map(item => ({ ...item, transactionKey: uuidV4() })),
    },
    processing: false,
    processed: false,
    cardProcessingErrorCount: action.data.errorMsg?.includes(
      'An error occurred while processing your card',
    ) ? state.cardProcessingErrorCount + 1 : state.cardProcessingErrorCount,
    // See https://github.com/lux-group/www-le-customer/pull/4393 for explanation of this
    orderFailure: true,
    // Store the transactionKey from when the order was created for failed transactions
    failedTransactionKey: state.orderTransactionKey,
    orderTransactionKey: state.cart.transactionKey,
  }),
  [CHECKOUT_APPLY_VELOCITY_BURN]: (state, action) => ({
    payment: {
      ...state.payment,
      partnerships: {
        ...state.payment.partnerships,
        velocity: {
          ...state.payment.partnerships.velocity,
          burn: {
            ...state.payment.partnerships.velocity?.burn,
            pointsBurned: action.points,
            isApplied: true,
          },
        },
      },
      modals: {
        ...state.payment.modals,
        isVelocityBurnActive: false,
      },
    },
  }),
  [CHECKOUT_CLEAR_VELOCITY_BURN]: (state) => ({
    payment: {
      ...state.payment,
      partnerships: {
        ...state.payment.partnerships,
        velocity: {
          ...state.payment.partnerships.velocity,
          burn: {
            ...state.payment.partnerships.velocity?.burn,
            pointsBurned: 0,
            isApplied: false,
          },
        },
      },
    },
  }),
  [CHECKOUT_APPLY_PARTNERSHIP_STATUS]: (state, action) => ({
    payment: {
      ...state.payment,
      partnerships: {
        ...state.payment.partnerships,
        [action.partnership]: {
          ...state.payment.partnerships[action.partnership],
          burn: {
            ...state.payment.partnerships[action.partnership]?.burn,
            isApplied: action.status,
          },
        },
      },
    },
  }),
  [CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS]: (state, action) => ({
    payment: {
      ...state.payment,
      modals: {
        ...state.payment.modals,
        velocity: {
          ...state.payment.modals.velocity,
          ...action.data,
        },
      },
    },
  }),
  [CHECKOUT_TOGGLE_CREDIT]: (state, action) => ({
    payment: {
      ...state.payment,
      useCredit: action.useCredit ?? !state.payment.useCredit,
    },
  }),
  [CHECKOUT_TOGGLE_GIFT_CARD]: (state) => ({
    payment: {
      ...state.payment,
      useGiftCard: !state.payment.useGiftCard,
    },
  }),
  [CHECKOUT_TOGGLE_LOYALTY_SIGNUP]: (state, action) => {
    return {
      loyalty: {
        ...state.loyalty,
        enrolCustomerAtCheckout: action.enrolLoyalty,
      },
    }
  },
  [CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN]: (state, action) => {
    return {
      loyalty: {
        ...state.loyalty,
        pointsToBurn: action.pointsToBurn,
      },
    }
  },
  [CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN]: (state, action) => {
    return {
      cart: {
        ...state.cart,
        restoredCartDetails: {
          ...state.cart.restoredCartDetails,
          pointsToBurn: undefined,
        },
      },
      loyalty: {
        ...state.loyalty,
        pointsToBurn: action.pointsToBurn,
      },
    }
  },
  [CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const flightItem = state.cart.items[itemIdx] as App.Checkout.FlightItem
    const flightData = flightItem.flights[action.flightIndex]

    const newFlights = flightItem.flights.map((flight, index) => {
      if (index === action.flightIndex) {
        return {
          ...flightData,
          extras: {
            ...flightData.extras,
            baggage: action.paxBaggageMap,
          },
        }
      }

      return flight
    })

    const newFlightItem = { ...flightItem, flights: newFlights }

    // Preserve ordering of items
    const newItemList = [...state.cart.items.slice(0, itemIdx), newFlightItem, ...state.cart.items.slice(itemIdx + 1)]

    return {
      cart: { ...state.cart, items: newItemList },
    }
  },
  [CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const { newFlightLegFares, newDepartingTotalFare, newReturningTotalFare, newTotalFare } = action

    const flightItem = state.cart.items[itemIdx] as App.Checkout.FlightItem
    const departing = flightItem.flights[0] ? { ...(flightItem.flights[0]) } : undefined
    const returning = flightItem.flights[1] ? { ...flightItem.flights[1] } : undefined

    if (departing && newDepartingTotalFare) {
      departing.cost = newDepartingTotalFare
    }

    if (returning && newReturningTotalFare) {
      returning.cost = newReturningTotalFare
    }

    let flights = flightItem.flights

    if (newFlightLegFares && flights.length === newFlightLegFares.length) {
      flights = flights.map((flight, index) => ({
        ...flight,
        cost: newFlightLegFares[index],
      }))
    }

    const newFlightItem = { ...flightItem, totalFare: newTotalFare, flights, departing, returning }

    // Preserve ordering of items
    const newItemList = [...state.cart.items.slice(0, itemIdx), newFlightItem, ...state.cart.items.slice(itemIdx + 1)]
    return { cart: { ...state.cart, items: newItemList } }
  },
  [CHECKOUT_UPDATE_EXPERIENCE_ITEM]: (state, action) => {
    const idx = state.cart.items.findIndex(item => item.itemType === CHECKOUT_ITEM_TYPE_EXPERIENCE && item.experienceId === action.id)
    if (idx === -1) { return {} }

    const experienceItem = state.cart.items[idx] as App.Checkout.ExperienceItem
    const newExperienceItem = {
      ...experienceItem,
      ...action.data.details,
      tickets: action.data?.tickets ?? experienceItem.tickets,
    }

    // Preserve ordering of cart items
    const newItemList = [...state.cart.items.slice(0, idx), newExperienceItem, ...state.cart.items.slice(idx + 1)]
    return {
      cart: { ...state.cart, items: newItemList },
    }
  },
  [CHECKOUT_APPLY_PROMO_CODE]: (state, action) => {
    const velocity = state.payment.partnerships.velocity ? {
      ...state.payment.partnerships.velocity,
      pointsBurned: 0, // Invalidate the partnership
    } : null

    return {
      promo: action.promotion,
      payment: {
        ...state.payment,
        partnerships: {
          ...(velocity && { velocity }),
        },
      },
      isFetchingPromo: false,
    }
  },
  [CHECKOUT_RESET_PROMO_CODE]: () => ({
    promo: undefined,
    fetchingPromoError: undefined,
  }),
  [CHECKOUT_FETCHING_PROMO_CODE]: () => ({
    isFetchingPromo: true,
    fetchingPromoError: undefined,
  }),
  [CHECKOUT_APPLY_PROMO_CODE_FAILED]: (state, action) => ({
    fetchingPromoError: action.error,
    isFetchingPromo: false,
  }),
  [CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS]: (state, action) => ({
    corporatePromoForm: {
      state: 'pending-input',
      sourceCodeName: action.promoCode,
      allowedEmailDomains: action.allowedEmailDomains,
      corporateName: action.corporateName,
    },
    isFetchingPromo: false,
  }),
  [CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS]: (state) => ({
    corporatePromoForm: {
      state: 'hidden',
      error: undefined,
      emailSubmitted: state.corporatePromoForm.emailSubmitted,
    },
  }),
  [CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY]: (state, action) => ({
    friendsAndFamilyPromoForm: {
      state: 'pending-input',
      sourceCodeName: action.promoCode,
      category: action.category,
    },
    isFetchingPromo: false,
  }),
  [CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY]: () => ({
    friendsAndFamilyPromoForm: {
      state: 'hidden',
    },
  }),
  [CHECKOUT_RESET_FLIGHT_ITEMS]: (state) => ({
    cart: {
      ...state.cart,
      items: state.cart.items.filter(item => !isFlightItem(item)),
    },
  }),
  [CHECKOUT_SET_RESTORE_CART_STATUS]: (state, action) => ({
    restoreCart: {
      ...state.restoreCart,
      ...action.data,
    },
  }),
  [CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW]: (state, action) => ({
    modifyFlightView: action.modifyFlightView,
  }),
  [CHECKOUT_UPDATE_HOTEL_ITEM_PRICING]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const hotelItem = state.cart.items[itemIdx]
    const newHotelItem = {
      ...hotelItem,
      newPrice: action.newPrice,
      newSurcharge: action.surcharge?.newSurcharge,
      newExtraGuestSurcharge: action.surcharge?.newExtraGuestSurcharge,
    }

    // Preserve ordering of items
    const newItemList = [...state.cart.items.slice(0, itemIdx), newHotelItem, ...state.cart.items.slice(itemIdx + 1)]
    return { cart: { ...state.cart, items: newItemList } }
  },
  [CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const hotelItem = state.cart.items[itemIdx]

    if (isBundleAndSaveItem(hotelItem)) {
      const hotelData = hotelItem.dates[action.offerId]

      if (hotelData) {
        const newHotelData = {
          ...hotelData,
          newPrice: action.newPrice,
          newSurcharge: action.surcharge?.newSurcharge,
          newExtraGuestSurcharge: action.surcharge?.newExtraGuestSurcharge,
        }
        const newHotelItem = {
          ...hotelItem,
          dates: {
            ...hotelItem.dates,
            [action.offerId]: newHotelData,
          },
        }

        const newItemList = [...state.cart.items.slice(0, itemIdx), newHotelItem, ...state.cart.items.slice(itemIdx + 1)]

        return { cart: { ...state.cart, items: newItemList } }
      }
    }

    return
  },
  [CHECKOUT_TOGGLE_DEV_TOOLS]: (state) => ({
    cart: {
      ...state.cart,
      isDevToolsEnabled: !state.cart.isDevToolsEnabled,
    },
  }),
  [CHECKOUT_SET_POST_PURCHASE]: (state, action) => ({
    cart: {
      ...state.cart,
      existingOrder: action.order,
      mode: action.mode,
    },
  }),
  [CHECKOUT_SET_VELOCITY_SSO]: (state, action) => ({
    payment: {
      ...state.payment,
      sso: {
        ...state.payment.sso,
        velocity: {
          ...state.payment.sso.velocity,
          ...action.data,
        },
      },
    },
  }),
  [CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER]: (state, action) => ({
    cart: {
      ...state.cart,
      arrivalFlightNumber: action.data,
    },
  }),
  [CHECKOUT_AGENT_BOOKING_DETAILS]: (state, action) => ({
    cart: {
      ...state.cart,
      agentBookingDetails: action.data,
    },
  }),
  [CHECKOUT_BUSINESS_BOOKING_DETAILS]: (state, action) => ({
    cart: {
      ...state.cart,
      businessBookingDetails: action.data,
    },
  }),
  [CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE]: (state, action) => ({
    ...state,
    csDepositPercentageOverride: action.depositOverride,
  }),
  [ACTIVATE_REBOOKING]: (state, action) => ({
    ...state,
    payment: {
      ...state.payment,
      rebookingID: action.data.rebookingID,
    },
  }),
  [CHECKOUT_SET_MULTI_CART_ITEM_MODE]: (state, action) => ({
    ...state,
    cart: {
      ...state.cart,
      isMultiItemMode: action.isMultiItemMode,
    },
  }),
  [CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE]: (state, action) => ({
    ...state,
    merchantFeePaymentType: action.paymentType,
  }),
  [SET_PAYPAL_PAYMENT_TYPE]: (state, action) => ({
    ...state,
    paypalPaymentType: action.paymentType,
  }),
  [CHECKOUT_SET_STRIPE_PAYMENT_METHOD]: (state, action) => ({
    ...state,
    stripePaymentMethod: {
      ...state.stripePaymentMethod,
      ...action.paymentMethod,
    },
  }),
  [CHECKOUT_ADD_ARRIVAL_DETAILS]: (state, action) => {
    const { itemId, arrivalDetails } = action
    return {
      cart: {
        ...state.cart,
        arrivalDetails: {
          ...state.cart.arrivalDetails,
          [itemId]: arrivalDetails,
        },
      },
    }
  },
  [CHECKOUT_SET_ARRIVAL_DETAILS_TIME]: (state, action) => {
    const { itemId, arrivalTime } = action
    return {
      cart: {
        ...state.cart,
        arrivalDetails: {
          ...state.cart.arrivalDetails,
          [itemId]: {
            ...state.cart.arrivalDetails[itemId],
            arrivalTime,
          },
        },
      },
    }
  },
  [CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER]: (state, action) => {
    const { itemId, arrivalFlightNumber } = action
    return {
      cart: {
        ...state.cart,
        arrivalDetails: {
          ...state.cart.arrivalDetails,
          [itemId]: {
            ...state.cart.arrivalDetails[itemId],
            arrivalFlightNumber,
          },
        },
      },
    }
  },
  [CHECKOUT_SET_PAYTO_BANK]: (state, action) => ({
    ...state,
    selectedPayToBank: action.selectedPayToBank,
  }),
  [CHECKOUT_FETCHING_PAYMENT_LINK]: () => ({
    securePayment: {
      isFetchingLink: true,
      securePaymentLink: undefined,
      securePaymentLinkType: undefined,
    },
  }),
  [CHECKOUT_FETCHING_PAYMENT_LINK_FAILED]: (state) => ({
    securePayment: {
      ...state.securePayment,
      isFetchingLink: false,
    },
  }),
  [CHECKOUT_SET_PAYMENT_LINK]: (_state, action) => ({
    securePayment: {
      isFetchingLink: false,
      securePaymentLink: action.data.securePaymentLink,
      securePaymentLinkType: action.data.securePaymentLinkType,
    },
  }),
  [CHECKOUT_SET_ORDER_ID]: (state, action) => ({
    ...state,
    orderId: action.orderId,
  }),
  [CHECKOUT_SET_MODE]: (state, action) => ({
    cart: {
      ...state.cart,
      mode: action.mode ?? 'default',
    },
  }),
  [CHECKOUT_SET_HAS_CAR_HIRE_INTENTION]: (state, action) => ({
    cart: {
      ...state.cart,
      hasCarHireIntention: action.hasCarHireIntention,
    },
  }),
  [CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP]: (state, action) => ({
    payment: {
      ...state.payment,
      agentHubPaymentMode: action.agentHubPaymentMode,
    },
  }),
  [SET_BEDBANK_SESSION]: (state, action) => ({
    sessions: {
      ...state.sessions,
      [action.data.sessionId]: {
        state: 'done',
        data: action.data,
      },
    },
  }),
  [CHECKOUT_CLEAR_RESTORED_PROMO_CODE]: (state) => ({
    cart: {
      ...state.cart,
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        promoCode: undefined,
      },
    },
  }),
  [CHECKOUT_CLEAR_RESTORED_USE_CREDIT]: (state) => ({
    cart: {
      ...state.cart,
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        creditsToApply: undefined,
      },
    },
  }),
  [CHECKOUT_SET_APPROVAL_REQUEST_ID]: (state, action) => ({
    cart: {
      ...state.cart,
      approvalRequestId: action.approvalRequestId,
    },
  }),
  [CHECKOUT_CLEAR_APPROVAL_REQUEST_ID]: (state) => ({
    cart: {
      ...state.cart,
      approvalRequestId: undefined,
    },
  }),
  [CHECKOUT_UPDATE_TRAVELLER_FORM_PREREQUISITE]: (state, action) => ({
    travellerFormPrerequisites: {
      ...state.travellerFormPrerequisites,
      [action.key]: { completed: action.completed },
    },
  }),
  [CHECKOUT_REMOVE_TRAVELLER_FORM_PREREQUISITE]: (state, action) => ({
    travellerFormPrerequisites: omitKeys([action.key], state.travellerFormPrerequisites),
  }),
  [CHECKOUT_TOGGLE_FAILED_ITEMS]: (state) => ({
    cart: {
      ...state.cart,
      hasFailedItems: true,
    },
  }),
})
